import CallFlowItem from '@/components/forms/calls/CallFlowItem';
import {
  CallMade,
  CallMissed,
  CallMissedOutgoing,
  CallReceived,
} from '@mui/icons-material';
import { Box, TextField, Tooltip, Typography } from '@mui/material';

export default function CallDetails({ data }) {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Typography variant="h4">
        {(data.outgoing && data.callFlow?.[0]?.connected && (
          <Tooltip title="Ausgehend">
            <CallMade sx={{ mr: 0.7, mb: -0.6 }} />
          </Tooltip>
        )) ||
          (data.outgoing && !data.callFlow?.[0]?.connected && (
            <Tooltip title="Ausgehend (keine Verbindung)">
              <CallMissedOutgoing sx={{ mr: 0.7, mb: -0.6 }} />
            </Tooltip>
          )) ||
          (!data.outgoing && data.pickup && (
            <Tooltip title="Eingehend">
              <CallReceived sx={{ mr: 0.7, mb: -0.6 }} />
            </Tooltip>
          )) || (
            <Tooltip title="Verpasst">
              <CallMissed sx={{ mr: 0.7, mb: -0.6 }} />
            </Tooltip>
          )}
        Call Details
      </Typography>
      <Typography sx={{ mb: 1 }}>
        Startzeit: {new Date(data.timeStart).toLocaleString()}
        <br />
        Endzeit: {new Date(data.timeEnd).toLocaleString()}
        <br />
      </Typography>
      <TextField
        disabled
        value={`${data.callerName} ${data.callerName !== data.callerNumber ? `(${data.callerNumber})` : ''}`}
        label="Anrufer:in"
      />
      <TextField
        disabled
        value={
          (data.callFlow?.[0]?.calledName &&
            `${data.callFlow?.[0]?.calledName} (${data.callFlow?.[0]?.calledNumber})`) ||
          data.callFlow?.[0]?.calledNumber ||
          ''
        }
        label="Angerufene Person"
      />
      {data.callFlow?.map((item, index) => (
        <CallFlowItem
          data={item}
          next={data?.callFlow?.[index + 1]}
          call={data}
          key={item.timeStart}
        />
      ))}
      {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
    </Box>
  );
}
